export const PARSING_MODE = {
    ANALYZE: 0,
    LOAD: 1,
    BINARY: 2,
};
